module.exports = __webpack_public_path__ + "img/face12.711b1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face12.jpg
// module id = ZrvI
// module chunks = 0